import script from "./OpeningTimes.vue?vue&type=script&setup=true&lang=js"
export * from "./OpeningTimes.vue?vue&type=script&setup=true&lang=js"

import "./OpeningTimes.vue?vue&type=style&index=0&id=43bfc5bf&lang=css"

const __exports__ = script;

export default __exports__